import React from "react";
import ReactDOM from "react-dom";
import { Provider as StateProvider } from "react-redux";

import 'promise-polyfill/src/polyfill';
import "./logic/canvasToBlobPolyfill";
import "./assets/styles/main.css";
import "./assets/styles/text.css";
import "./assets/styles/panel.css";
import "./assets/styles/button.css";
import "./assets/styles/desktop.css";

import WebCLRLoader from "./Components/WebCLRLoader";
import IconDefinitions from "./Components/IconDefinitions";
import * as serviceWorker from "./serviceWorker";
import { store } from "./logic/store";
import App from "./Components/App";
import { subscribeLoggingFunction } from "./logic/eventLogger";
import { defaultState } from "./logic/reducers/configuration";
import { setBaseTag } from "./logic/tenant";

if (process.env.NODE_ENV === "development") {
  subscribeLoggingFunction((name, params) =>
    console.log("Event: " + name, params)
  );
}

setBaseTag(defaultState.tenant);

ReactDOM.render(
  <StateProvider store={store}>
    <IconDefinitions />
    <WebCLRLoader />
    <App />
  </StateProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
